import React from 'react';
import { ApolloError, gql } from '@apollo/client';
import { ResetPasswordController, ResetPasswordControllerProps } from './ResetPassword.controller';
import { useResetPasswordMutation } from '../../../models/graphql';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';
import { getApolloError } from '../../../constants/apollo-errors';

export type ResetPasswordApolloProps = Omit<
  ResetPasswordControllerProps,
  'loading' | 'requestError' | 'resetPasswordData' | 'resetPasswordMutation'
> & {
  //
};

gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(resetToken: $token, newPassword: $password)
  }
`;

export const ResetPasswordApollo = (props: ResetPasswordApolloProps): JSX.Element => {
  let requestError: string | JSX.Element = '';
  let loading = false;
  let resetPasswordData: undefined | boolean;

  const [resetPasswordMutation, { loading: resetPasswordLoading, error, data }] = useResetPasswordMutation({
    fetchPolicy: 'no-cache'
  });

  if (resetPasswordLoading) {
    requestError = '';
    loading = true;
  }
  if (error) {
    const errorForRemapping = error as ApolloError;
    requestError = remapApolloErrors(errorForRemapping);
    loading = false;
  }

  if (!props.token || !props.email) {
    requestError = getApolloError('NOT_FOUND', 'resetPassword', { type: 'RESET_PASSWORD' });
  }

  if (data) {
    loading = false;
    if (data.resetPassword) {
      resetPasswordData = data.resetPassword;
      requestError = '';
    } else {
      requestError = getApolloError('RESET_NO_USER_ASSOCIATED', 'resetPassword');
    }
  }

  const args: ResetPasswordControllerProps = {
    ...props,
    loading,
    requestError,
    resetPasswordData,
    resetPasswordMutation
  };

  return <ResetPasswordController {...args} />;
};
